import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { setMatrixFilters } from "../supplierOutflowSlice";
import { fetchSupplierOutflowMatrix } from "../supplierOutflowThunk";
import { getYear } from "../../../../lib/yearMonth";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";

const SupplierOutflowMatrixFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { matrix } = useSelector((state) => state.supplierOutflow);
  const years = getYear();

  useEffect(() => {
    if (!matrix.filters.year) {
      dispatch(setMatrixFilters({ year: dayjs().year() }));
    }
  }, [dispatch, matrix.filters.year]);

  const handleReport = () => {
    dispatch(fetchSupplierOutflowMatrix(matrix.filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded successfully");
      } else {
        messageApi.error("Failed to fetch records");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
          <label>Year</label>
          <SearchListAutoComplete
            optionsList={years.map((y) => ({
              sale_id: y.year,
              display_text: y.year,
              raw: y,
            }))}
            value={
              matrix.filters.year
                ? { sale_id: matrix.filters.year, display_text: String(matrix.filters.year) }
                : undefined
            }
            onSelect={(obj) =>
              dispatch(setMatrixFilters({ year: obj?.sale_id ? Number(obj.sale_id) : null }))
            }
            placeholder="Year"
            showAddNew={false}
          />
        </Col>

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={6}
          className="filter-item"
          style={{ display: "flex", alignItems: "flex-end", height: 64 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            loading={matrix.loading}
            style={{ height: 35.19 }}
            block
            data-testid="matrix-report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default SupplierOutflowMatrixFilters;
